import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, withKeys as _withKeys, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "card" }
const _hoisted_2 = { class: "search-container" }
const _hoisted_3 = { class: "p-input-icon-left" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-search" }, null, -1)
const _hoisted_5 = { class: "card-body pt-0" }

import {
  ref,
  onMounted,
} from "vue";
import DataTable from "primevue/datatable";
import Column from "primevue/column";
import InputText from "primevue/inputtext";
import {fetchDocumentsStockDocuments} from "@/_services/document/document";

const defaultRowsPerPage = 10;

export default /*#__PURE__*/_defineComponent({
  __name: 'StockDocumentList',
  setup(__props) {

const isLoading = ref<boolean>(true);
const documents = Array<Document>();
const tableData = ref<Array<Document>>(documents);
const currentPage = ref<number>(0);
const rows = ref<number>(10);
const totalRecords = ref<number>(0);
const page = ref<number>(1);
const rowsPerPageOptions = [defaultRowsPerPage, 25, 100];
const criteria = ref<string>("");


onMounted(async () => {
  showSpinner();
  await populateDatatable();
});
async function populateDatatable() {
  const [loadingDt, totalRecordsDt, tableDataDt] = await fetchDocumentsStockDocuments(1, rows.value, page.value, criteria.value);
  isLoading.value = loadingDt.value;
  tableData.value = tableDataDt.value;
  totalRecords.value = totalRecordsDt.value;
  
  if (isLoading.value === false) {
      hideSpinner();
  }
}
const onPaginate = async (e) => {
    showSpinner();
    rows.value = e.rows;
    currentPage.value = e.page;
    page.value = e.page + 1;
    await populateDatatable();
};
const onFilterDt = async() => {
    showSpinner();
    rows.value = 10;
    page.value = 1;
    await populateDatatable();
};

const onClearInputFilter = () => {
    if (criteria.value === "") {
        showSpinner();
        rows.value = 10;
        page.value = 1;
        populateDatatable();
    }
};

const showSpinner = () => {
    isLoading.value = true;
}
const hideSpinner = () => {
    isLoading.value = false;
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(DataTable), {
      value: tableData.value,
      rows: rows.value,
      paginator: true,
      loading: isLoading.value,
      rowsPerPageOptions: rowsPerPageOptions,
      lazy: "",
      onPage: onPaginate,
      currentPage: currentPage.value,
      totalRecords: totalRecords.value
    }, {
      header: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("span", _hoisted_3, [
            _hoisted_4,
            _createVNode(_unref(InputText), {
              modelValue: criteria.value,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((criteria).value = $event)),
              placeholder: "Rechercher un produit",
              onKeyup: _withKeys(onFilterDt, ["enter"]),
              onInput: onClearInputFilter
            }, null, 8, ["modelValue", "onKeyup"])
          ])
        ])
      ]),
      empty: _withCtx(() => [
        _createTextVNode("Aucun résultat trouvé.")
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_unref(Column), {
            field: "stockId",
            header: "Id de stock"
          }),
          _createVNode(_unref(Column), {
            field: "productName",
            header: "Nom du produit"
          }),
          _createVNode(_unref(Column), {
            field: "supplierName",
            header: "Fournisseur"
          }),
          _createVNode(_unref(Column), {
            field: "stockType",
            header: "Type de stock"
          }, {
            body: _withCtx((slotProps) => [
              _createTextVNode(_toDisplayString(slotProps.data.stockType == 1 ? 'Partagé' : 'Individuel'), 1)
            ]),
            _: 1
          }),
          _createVNode(_unref(Column), {
            field: "status",
            header: "Statut du stock"
          }, {
            body: _withCtx((slotProps) => [
              _createTextVNode(_toDisplayString(slotProps.data.status == 1 ? 'Actif' : 'Inactif'), 1)
            ]),
            _: 1
          }),
          _createVNode(_unref(Column), {
            field: "documentStock",
            header: "Stock de document"
          }),
          _createVNode(_unref(Column), {
            field: "productStock",
            header: "Stock du produit"
          }),
          _createVNode(_unref(Column), {
            field: "productStockThreshold",
            header: "Seuil stock"
          })
        ])
      ]),
      _: 1
    }, 8, ["value", "rows", "loading", "currentPage", "totalRecords"])
  ]))
}
}

})